import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppStore } from '@app/store/app';
import { TranslocoModule } from '@jsverse/transloco';
import { HrpSelectComponent, HrpSelectOptionComponent, ProgressSpinnerComponent } from '@shared/ui';

@Component({
  selector: 'page-account-settings',
  templateUrl: 'settings.component.html',
  styleUrls: ['settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    ProgressSpinnerComponent,
    HrpSelectComponent,
    HrpSelectOptionComponent,
    TranslocoModule,
  ],
})
export class PageAccountSettingsComponent {
  private _appStore = inject(AppStore);
  $loading: WritableSignal<boolean> = signal(false);

  get $selectedLanguage() {
    return this._appStore.$language;
  }

  get languageMap() {
    return { en: 'account-english', de: 'account-german' };
  }

  constructor() {
    this._simulateLoadingAnimation();
  }

  onLanguageChange(language: string) {
    this._appStore.setLanguage(language);
  }

  private _simulateLoadingAnimation() {
    this.$loading.set(true);
    setTimeout(() => {
      this.$loading.set(false);
    }, 150);
  }
}
